import { render } from "./LinkComponent.vue?vue&type=template&id=3477f14f"
import script from "./LinkComponent.vue?vue&type=script&lang=js"
export * from "./LinkComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__